import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
import { useTheme } from 'styled-components';
import { FilledWarningIcon, IconWrapper, OutlineWarningIcon } from './styled.js';
export const HoverableWarningIcon = () => {
    const { colors } = useTheme();
    return (_jsxs(IconWrapper, { children: [_jsx(OutlineWarningIcon, { size: 16, color: colors.critical100 }), _jsx(FilledWarningIcon, { size: 16, color: colors.critical100, filled: true })] }));
};
